import { WltpInfo } from '~/app/market-config';
import { ConfiguredCarTechnicalDataQuery } from '~/graphql/__generated__/graphql';
import { getEecLabelUrl } from '~/utils/technical-data-media-items';

export function eecDataMerger(wltpInfo: WltpInfo, technicalData: ConfiguredCarTechnicalDataQuery | undefined) {
	if (!wltpInfo) return;

	const eecUrl = getEecLabelUrl(technicalData?.configuredCar.technicalDataV2?.mediaItems);

	return {
		...wltpInfo,
		url: eecUrl
			? {
					url: eecUrl,
					pathParams: {},
					queryParams: [],
				}
			: wltpInfo.url,
	};
}
